<template>
  <div class="staff-header" :class="{'open':open}">
    <a :href="homeUrl" target="_blank">
      <img class="tigerair-tw" alt :src="images.tigerairTaiwan" />
    </a>
    <div class="user-info">
      <span class="margin-right">Welcome back,</span>
      <div class="margin-right">
        <div class="user-name">{{fullName}}</div>
        <div class="staff-id">Staff ID:{{staffId}}</div>
      </div>
      <a @click="logout" href="javascript:void(0)">
        <img class="logout" :src="images.logout" alt />
      </a>
    </div>
    <div class="nav" :class="{'open':open}">
      <div class="nav-btn" @click="open=!open"></div>
      <div @click="open=false" class="list-container">
        <router-link to="/home">Home</router-link>
        <router-link to="/bookings">My Bookings</router-link>
        <router-link to="/profile">My Profile</router-link>
        <router-link to="/nominees">My Nominees</router-link>
        <a href="javascript:void(0);" @click="logout">Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
import images from "../../core/images";
import config from "../../core/config";
import { mapState, mapActions } from "vuex";
import { getFullName } from "../../core/staff-helper";

export default {
  name: "staff-header",
  methods: {
    ...mapActions(["logout"])
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    images: () => images,
    homeUrl: () => config.TIGERAIRTW_URL,
    ...mapState({
      staffId: s => s.userInfo?.staffId,
      fullName: s => getFullName(s.userInfo || {})
    })
  },
  mounted() {
    document.body.classList.add("gray-bg");
  },
  destroyed() {
    document.body.classList.remove("gray-bg");
  }
};
</script>

<style scoped lang="scss">
.staff-header {
  top: 0;
  left: 0;
  z-index: 1;
  width: 105%;
  position: fixed;
  padding: 0.5rem 1rem;
  padding-right: 7.5%;
  background-color: #fff;
  box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
  > * {
    display: inline-block;
  }
  .tigerair-tw {
    height: 4rem;
  }
  .logout {
    color: $orange;
    height: 1.25rem;
  }
  .user-info {
    display: none;
    @media (min-width: 992px) {
      float: right;
      display: block;
      padding: 0.5rem;
      letter-spacing: 0.5px;
      > * {
        vertical-align: top;
        display: inline-block;
      }
      .user-name {
        color: $orange;
        font-weight: bold;
      }
      .staff-id {
        color: $orange;
        font-size: 0.875rem;
      }
    }
  }
  .nav {
    display: none;
    @media (max-width: 991px) {
      display: block;
      .nav-btn {
        top: 1.5rem;
        right: 2rem;
        width: 30px;
        z-index: 999;
        height: 26px;
        position: fixed;
        cursor: pointer;
        border-top: 2px solid $orange;
        -webkit-transition: all 0.3s ease-in;
        -moz-transition: all 0.3s ease-in;
        transition: all 0.3s ease-in;
        &::before {
          left: 0;
          top: 10px;
          content: "";
          height: 2px;
          width: 30px;
          display: block;
          position: absolute;
          background: $orange;
          -webkit-transition: all 0.3s ease-in;
          -moz-transition: all 0.3s ease-in;
          transition: all 0.3s ease-in;
        }

        &::after {
          left: 0;
          bottom: 0;
          height: 2px;
          content: "";
          width: 30px;
          display: block;
          position: absolute;
          background: $orange;
          -webkit-transition: all 0.3s ease-in;
          -moz-transition: all 0.3s ease-in;
          transition: all 0.3s ease-in;
        }
      }
      .list-container {
        left: 0;
        right: 0;
        top: 5rem;
        height: 0;
        margin: 0;
        padding: 0;
        position: fixed;
        overflow: hidden;
        list-style: none;
        background-color: white;
        -webkit-transition: all 0.3s ease-in;
        -moz-transition: all 0.3s ease-in;
        transition: all 0.3s ease-in;
        > * {
          height: 2.5rem;
          padding: 0.5rem;
          width: 100%;
          color: $light-black;
          display: block;
          overflow: hidden;
          text-align: center;
          white-space: nowrap;
          text-decoration: none;
          border-bottom: solid 1px transparent;
          -webkit-transition: all 0.3s ease-in;
          -moz-transition: all 0.3s ease-in;
          transition: all 0.3s ease-in;

          &:hover,
          &.router-link-active {
            color: white;
            background-color: $orange;
          }
        }
      }
      &.open {
        .nav-btn {
          border-color: transparent;
          &::before {
            left: -2px;
            width: 33px;
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            transform: rotate(45deg);
          }
          &::after {
            left: -2px;
            width: 33px;
            bottom: 11px;
            -webkit-transform: rotate(135deg);
            -moz-transform: rotate(135deg);
            transform: rotate(135deg);
          }
        }
        .list-container {
          height: 12.5rem;
          > * {
            border-color: $light-gray;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
body {
  padding-top: 6rem;
}
#main-content {
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.staff-header.open + #main-content {
  opacity: 0.4;
  margin-top: 12rem;
  pointer-events: none;
}
</style>
